import { useEffect } from 'react';

import { useWatch } from 'react-hook-form';

import { ItemRowProps } from './ItemRow';

/*
  This hook is used to watch the initial values of the last row via isLast prop.
  If any of the selected keys change from undefined to something else -
  onClick will be called, new row will be added and the current row will no longer be monitored
*/

export function useWatchSelf<T>(
  { onClick, isLast, isFull, prefix }: ItemRowProps,
  keys: Array<keyof T>,
) {
  const self = useWatch({ name: keys.map(el => `${prefix}.${String(el)}`), disabled: !isLast });
  const hasChangedItems = self.some(el => el !== undefined);

  useEffect(() => {
    if (hasChangedItems && isLast && !isFull && onClick) {
      onClick();
    }
  }, [isLast, isFull, onClick, hasChangedItems]);
}
